import pagination from "./elements/pagiantion";

const inventories = {
  loading: false,
  pagination: pagination,
  list: null,
};

export default inventories;
